// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Redux:
import { setDismissedInstallAppBanner } from 'actions/site'

class AppBanner extends React.Component {
	handleClose = () => {
		this.props.dispatch( setDismissedInstallAppBanner() )
	}

	handleOpen = () => {
		const { isIos } = this.props

		this.handleClose()

		if ( isIos ) {
			window.open( siteData.app_store_url_ios )
		} else {
			window.open( siteData.app_store_url_android )
		}
	}

	render() {
		const { dismissedInstallAppBanner, isIos } = this.props

		if ( dismissedInstallAppBanner ) {
			return null
		}

		return (
			<div className="install-web-app-banner">
				<div className="-close">
					<i className="icon-close" onClick={ this.handleClose } />
				</div>

				<div className="-icon" onClick={ this.handleOpen }>
					<img src={ `${siteData.images_url}mobile-app/install-banner/app-icon-r4.png` } alt="" />
				</div>

				<div className="-text" onClick={ this.handleOpen }>
					<strong>Faith FM Australia</strong><br />
					<span>Seventh-day Adventist Church (Australia)</span><br />

					{ isIos &&
						<span>GET &mdash; On the App Store</span>
					||
						<span>GET &mdash; On the Play Store</span>
					}
				</div>

				<div className="-view">
					<span onClick={ this.handleOpen }>View</span>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		dismissedInstallAppBanner: state.site.dismissedInstallAppBanner,
		isIos: state.site.isIos
	}
}

export default connect( mapStateToProps )( AppBanner )
